import React from 'react';
import {CSVLink} from "react-csv";
import {useReport} from "../../../utilities/contexts/report-context";
import {dateToFileName, formatInt, formatPrice, nameToFileName} from "../../../utilities/data/parser";
import HorizontalLabelledField from "../../UI/Fields/HorizontalLabelledField";
import VerticalLabelledField from "../../UI/Fields/VerticalLabelledField";
import CsvButton from "../../UI/CSVButton";
import RowAligned from "../../UI/Structure/RowAligned";
import PrintButton from "../../UI/PrintButton";

const headers = [
    {label: "Nr Lotto", key: "nrlotto"},
    {label: "Provenienza", key: "buying_article"},
    {label: "Articolo", key: "sales_article"},
    {label: "Cliente", key: "client"},
    {label: "Resa", key: "performance"},
    {label: "Costo Mq", key: "costs_per_mq"},
    {label: "Ve/Mq", key: "sold_per_mq"},
    {label: "Diff %", key: "diff_percentage"},
    {label: "N. Mq Vend.", key: "sold_mq"},
    {label: "Tot costo", key: "total_cost"},
    {label: "Tot Vend", key: "total_profit"},
    {label: "Margine", key: "margin"},
    {label: "Tot Nr. Pz", key: "nrpz"},
    {label: "Documento", key: "document"}
];

const CostsTotals = () => {

    const {costsData, costsFormData} = useReport();

    const handlePrint = () => {

    }

    const getCsvFileName = () => {
        const start = dateToFileName(costsFormData.date_from);
        const end = dateToFileName(costsFormData.date_to);
        const client = costsFormData?.client?.name ? nameToFileName(costsFormData.client.name) + "_" : "";
        return `costi_lavorazione_${client}dal_${start}_al_${end}`;
    }

    const buildCsvData = () => {
        if (!Array.isArray(costsData?.list)) return [];
        return costsData.list.map(el => {
            const doc = el?.document || {};
            const documentStr = [
                doc?.type?.name,
                doc?.nrdocfor,
                doc?.datadocfor,
                doc?.company_name
            ].filter(Boolean).join(" ");
            return {
                ...el,
                performance: formatPrice(el?.performance ?? 0),
                costs_per_mq: formatPrice(el?.costs_per_mq ?? 0),
                sold_per_mq: formatPrice(el?.sold_per_mq ?? 0),
                diff_percentage: formatPrice(el?.diff_percentage ?? 0),
                sold_mq: formatPrice(el?.sold_mq ?? 0),
                total_cost: formatPrice(el?.total_cost ?? 0),
                total_profit: formatPrice(el?.total_profit ?? 0),
                margin: formatPrice(((el?.total_profit ?? 0) - (el?.total_cost ?? 0))),
                nrpz: formatInt(el?.nrpz ?? 0),
                document: documentStr || ""
            };
        });
    }

    return (
        <div className="flex flex-row justify-between gap-2 border-t border-black p-1">
            <RowAligned>
                <PrintButton onClick={handlePrint}/>
                {Array.isArray(costsData?.list) && costsData.list.length > 0 && (
                    <CSVLink data={buildCsvData()}
                             filename={getCsvFileName()}
                             separator={";"}
                             headers={headers}>
                        <CsvButton />
                    </CSVLink>
                )}

            </RowAligned>

            <VerticalLabelledField label="Totali">
                <div className="flex flex-row gap-2">
                    <HorizontalLabelledField label="Nrpz">
                        {costsData.totals?.nrpz ? formatInt(costsData.totals?.nrpz): "..."}
                    </HorizontalLabelledField>
                    <HorizontalLabelledField label="Costi">
                        {formatPrice(costsData.totals?.costs)}€
                    </HorizontalLabelledField>
                    <HorizontalLabelledField label="Vendite">
                        {formatPrice(costsData.totals?.sales)}€
                    </HorizontalLabelledField>
                    <HorizontalLabelledField label="Profitti">
                        {formatPrice(costsData.totals?.profit)}€
                    </HorizontalLabelledField>
                </div>
            </VerticalLabelledField>
        </div>
    );
};

export default CostsTotals;